import Vue from 'vue';
import App from './App';
import router from './router';
import VS2 from 'vue-script2';

import './assets/css/animate.css';
import './assets/css/bootsnav.css';
import './assets/css/style.css';
import './assets/css/header.css';
import './assets/css/modal.css';
import './assets/css/slider.css';
import './assets/css/images-circle.css';
import './assets/css/footer.css';
import './assets/css/resultado-busqueda.css';

Vue.config.productionTip = false;
Vue.filter('addPlusSign', function(value) {
    if (value.trim()[0] != '+' && !isNaN(value.trim()[0])) {
        value = `+${value}`;
    }
    return value;
});

Vue.use(VS2);

router.beforeEach((to, from, next) => {
    const nearestWithTitle = to.matched
        .slice()
        .reverse()
        .find(r => r.meta && r.meta.title);
    const nearestWithMeta = to.matched
        .slice()
        .reverse()
        .find(r => r.meta && r.meta.metaTags);

    if (nearestWithTitle) document.title = nearestWithTitle.meta.title;
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(
        el => el.parentNode.removeChild(el)
    );

    // Skip rendering meta tags if there are none.
    if (!nearestWithMeta) return next();

    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags
        .map(tagDef => {
            const tag = document.createElement('meta');

            Object.keys(tagDef).forEach(key => {
                tag.setAttribute(key, tagDef[key]);
            });

            // We use this to track which meta tags we create, so we don't interfere with other ones.
            tag.setAttribute('data-vue-router-controlled', '');
            window.scrollTo(0, 0);
            next();

            return tag;
        })
        // Add the meta tags to the document head.
        .forEach(tag => document.head.appendChild(tag));
    next();
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
    render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js